export interface Comando {
  cmd: string; // inclui a barra
  desc: string;
}

// Comandos estilo Telegram — agro + OpenClaw. Mostrados no menu e no
// autocomplete ao digitar "/". (No futuro podem vir do backend por agente.)
export const COMANDOS: Comando[] = [
  { cmd: '/relatorio', desc: 'Gerar relatório da fazenda' },
  { cmd: '/clima', desc: 'Previsão do tempo do talhão' },
  { cmd: '/talhao', desc: 'Resumo de um talhão' },
  { cmd: '/new', desc: 'Nova conversa (limpa o contexto)' },
  { cmd: '/compact', desc: 'Resumir e compactar a conversa' },
  { cmd: '/skill', desc: 'Rodar uma skill do agente' },
  { cmd: '/help', desc: 'Comandos disponíveis' },
];

export function filtrarComandos(texto: string): Comando[] {
  if (!texto.startsWith('/')) return [];
  const q = texto.slice(1).toLowerCase();
  return COMANDOS.filter((c) => c.cmd.slice(1).toLowerCase().startsWith(q));
}
